import { render, staticRenderFns } from "./markAsReadButton.vue?vue&type=template&id=b6c12c20"
import script from "./markAsReadButton.vue?vue&type=script&lang=js"
export * from "./markAsReadButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/francescobarbieri/Dev/brain/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6c12c20')) {
      api.createRecord('b6c12c20', component.options)
    } else {
      api.reload('b6c12c20', component.options)
    }
    module.hot.accept("./markAsReadButton.vue?vue&type=template&id=b6c12c20", function () {
      api.rerender('b6c12c20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/admin-panel/components/admin/notifications/markAsReadButton.vue"
export default component.exports